/* eslint-disable sort-imports */
import { terms } from 'common/terms'
import SettingsInfoDialog from './SettingsInfoDialog'
import { faCog } from '@fortawesome/free-solid-svg-icons'
import { useIntl } from 'react-intl'
import { useState } from 'react'
import { IconButton } from '@material-ui/core'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { IconProp } from '@fortawesome/fontawesome-svg-core'

interface Props {
  finalFormat: string
  matchFormat: string
  mexicanoCourtSelection: string
  resultSorting: string
  teamFormat: string
  tournamentType: string
}

const SettingsInfoButton = ({
  finalFormat,
  matchFormat,
  mexicanoCourtSelection,
  resultSorting,
  teamFormat,
  tournamentType,
}: Props) => {
  const { formatMessage: fm } = useIntl()
  const [showDialog, setShowDialog] = useState(false)

  return (
    <>
      <IconButton
        onClick={() => setShowDialog(true)}
        data-test-id="settings-info-button"
        title={fm(terms.settingsInfo)}
        color="primary"
      >
        <FontAwesomeIcon icon={faCog as IconProp} />
      </IconButton>
      <SettingsInfoDialog
        open={showDialog}
        onClose={() => setShowDialog(false)}
        finalFormat={finalFormat}
        matchFormat={matchFormat}
        mexicanoCourtSelection={mexicanoCourtSelection}
        resultSorting={resultSorting}
        teamFormat={teamFormat}
        tournamentType={tournamentType}
      />
    </>
  )
}

export default SettingsInfoButton
